import PropTypes from 'prop-types'
import React, { useCallback, useEffect, useState } from 'react'
import { CHECKOUT_SERVICE_ACTIONS } from '../../../../shared/constants.js'
import { logger } from '../../../lib/logging'
import { feathers as app } from '../../../feathers.js'
import PayButton from './PayButton.jsx'

const HostedCheckoutButton = ({ team }) => {
  const [loading, setLoading] = useState(false)
  const [mounted, setMounted] = useState(false)

  useEffect(() => {
    setMounted(true)
    return () => setMounted(false)
  }, [])

  const goToCheckout = useCallback(() => {
    setLoading(true)
    app
      .service('/api/subscription/checkout')
      .get({
        teamId: team.id,
        queryParams: {
          redirectUrl: window.location.href,
          cancelUrl: window.location.href
        },
        action: CHECKOUT_SERVICE_ACTIONS.CHECKOUT
      })
      .then((checkoutUrl) => mounted && (window.location.href = checkoutUrl))
      .catch((err) =>
        logger.error('HostedCheckoutButton goToCheckout err', err)
      )
  }, [mounted, team])

  return <PayButton loading={loading} onClick={goToCheckout} />
}

HostedCheckoutButton.propTypes = {
  team: PropTypes.object.isRequired
}

export default HostedCheckoutButton
